import {BitrixVue} from 'ui.vue3';
import { mapState } from 'ui.vue3.pinia';
import { vplSiteStore } from '../../store/vplstore';
import { ItemEditBtns } from '../../services/itemeditbtns/itemeditbtns';

export const WhatsappHeader = {
    components: {
        ItemEditBtns
    },
    props: {
        tagClass: String
    },
    computed: {
        ...mapState(vplSiteStore, ['templateData'])
    },
    template: `
        <ItemEditBtns  v-if="templateData && templateData.whatsapp && templateData.whatsapp.EDIT_BUTTON" :onclick="templateData.whatsapp.EDIT_BUTTON">
            Редактировать Whatsapp
        </ItemEditBtns>
        <a v-if="templateData && templateData.whatsapp && templateData.whatsapp.CONTENT"
            :href="templateData.whatsapp.CONTENT"
            target="_blank"
            rel="nofollow"
            class="contacts-block__mes">
            <svg class="icon icon-wa"><use xlink:href="#icon-wa"></use></svg>
        </a>
    `
}